<template>
  <div>
    <h1>Tratativas</h1>

    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovaTratativa" style="z-index: 1000;" />

    <SGPFormSelectComponent :name="'exibirItensDeletados'" :listaDeOptions="opcoesSelect" v-model="mostrarExcluidos"
      :optionLabel="'nome'" :placeholder="'Visualizar Itens Deletados'"
      :error="validationErrors.first('exibirItensDeletados')" data-vv-as="Visualizar Itens Deletados"
      :optionSelecione="'Não'" @change="filtrarTratativasDeletadas($event)" />

    <template v-if="listaDeTratativas.length">
      <SGPPaginacaoComponent v-if="paginacao" :paginacao="paginacao" @sgpAtualizarPaginacao="realizarPaginacao"
        :key="paginacao?.current_page">
        <SGPTabelaComponent :colunas="colunas" :dados="listaDeTratativas"
          @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
          @sgpTabelaEditarSelecionadoEmit="editarSelecionado" @sgpTabelaDeletarSelecionadoEmit="deletarSelecionados" @sgpTabelaRestaurarSelecionadoEmit="restaurarSelecionado">
          <template v-slot:item.selecionar="{ item }">
            <div class="container-botao-tabela">
              <SGPFormBotaoComponent fab rounded color="warning" x-small @click="editarItem(item)">
                <v-icon color="white" small>mdi-pencil</v-icon>
              </SGPFormBotaoComponent>
              <SGPFormBotaoComponent class="ml-2" fab rounded color="primary" x-small @click="excluirItem(item)">
                <v-icon color="white" small>mdi-delete</v-icon>
              </SGPFormBotaoComponent>
            </div>
          </template>
        </SGPTabelaComponent>
      </SGPPaginacaoComponent>
      <SGPTabelaComponent v-else :colunas="colunas" :dados="listaDeTratativas"
        @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados" @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
        @sgpTabelaDeletarSelecionadoEmit="deletarSelecionados" @sgpTabelaRestaurarSelecionadoEmit="restaurarSelecionado">
        <template v-slot:item.selecionar="{ item }">
          <div class="container-botao-tabela">
            <SGPFormBotaoComponent fab rounded color="warning" x-small @click="editarItem(item)">
              <v-icon color="white" small>mdi-pencil</v-icon>
            </SGPFormBotaoComponent>
            <SGPFormBotaoComponent class="ml-2" fab rounded color="primary" x-small @click="excluirItem(item)">
              <v-icon color="white" small>mdi-delete</v-icon>
            </SGPFormBotaoComponent>
          </div>
        </template>
      </SGPTabelaComponent>
    </template>

    <SGPAlertaComponent v-else />

    <SGPModalComponent v-if="abrirModal" tamanho="sm" titulo="Tratativa" :mostrarFooter="false"
      @sgpModalFechar="fecharModal">
      <FormularioTratativaComponent :tipoFormulario="tipoFormulario" :tratativa="tratativaSelecionada"
        @tratativaSalva="fecharModal" />
    </SGPModalComponent>

    <SGPConfirmacaoDelecaoComponent v-if="abrirModalDeletarDados" @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()" />

    <SGPLoadingComponent v-if="loadingTratativa" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioTratativaComponent from '../components/FormularioTratativaComponent.vue'
import deletar from '@/common/mixins/deletar.js'

export default {
  name: 'CtrlTratativasPage',
  components: { FormularioTratativaComponent },
  mixins: [deletar],

  data() {
    return {
      tratativasSelecionadas: [],
      abrirModal: false,
      abrirModalDeletarDados: false,
      mostrarExcluidos: false,
      tipoFormulario: 'salvar',
      tratativaSelecionada: {},

      opcoesSelect: [
        {
          'id': true,
          'nome': 'Sim'
        },
        {
          'id': false,
          'nome': 'Não'
        }
      ],
    }
  },

  created() {
    this.listarTratativas(
      this.montarParametros()
    )
  },

  computed: {
    ...mapGetters('ctrlTratativas', ['listaDeTratativas', 'loadingTratativa', 'paginacao']),

    colunas() {
      return [
        {
          key: 'selecionar',
          label: 'Ações',
          sortable: false
        },
        {
          key: 'tratativa',
          label: 'Tratativa',
          sortable: false,
          width: 200
        },
        {
          key: 'observacao',
          label: 'Observação',
          sortable: false,
          width: 500
        },
        {
          key: 'restaurar',
          label: 'Restaurar',
          sortable: false
        }
      ]
    }
  },

  methods: {
    ...mapActions('ctrlTratativas', [
      'listarTratativas',
      'excluirTratativas',
      'restaurarTratativa'
    ]),

    montarParametros(extra = {}) {
      return {
        mostrarExcluidos: this.mostrarExcluidos,
        per_page: this.paginacao?.per_page || 20,
        page: this.paginacao?.current_page || 1,
        current_page: this.paginacao?.current_page || 1,
        ...extra
      }
    },

    filtrarTratativasDeletadas(event) {
      if (typeof event == 'undefined') {
        return false;
      }

      let payload = {
        ...this.paginacao,
        mostrarExcluidos: this.mostrarExcluidos
      }

      this.listarTratativas(payload);
    },

    gerenciadorDeSelecionados(selecionados) {
      this.tratativasSelecionadas = selecionados
    },

    adicionarNovaTratativa() {
      this.tratativaSelecionada = {}
      this.tipoFormulario = 'salvar'
      this.abrirModal = true
    },

    editarSelecionado() {
      this.tipoFormulario = 'editar'
      this.tratativaSelecionada = { ...this.tratativasSelecionadas[0] }
      this.abrirModal = true
    },

    editarItem(item) {
      this.tratativasSelecionadas = [item]
      setTimeout(() => {
        this.editarSelecionado()
      }, 50)
    },

    excluirItem(item) {
      this.tratativasSelecionadas = [item]
      setTimeout(() => {
        this.deletarSelecionados()
      }, 50)
    },

    confirmarDelecao() {
      this.excluirTratativas(this.tratativasSelecionadas)
      this.abrirModalDeletarDados = false
    },

    cancelarDelecao() {
      this.abrirModalDeletarDados = false
    },

    fecharModal() {
      this.abrirModal = false
      this.tratativaSelecionada = {}
      this.listarTratativas(this.montarParametros())
    },

    restaurarSelecionado(item) {
      this.restaurarTratativa(item.id);
    },

    realizarPaginacao(pagina) {
      this.listarTratativas(this.montarParametros({
        page: pagina.current_page,
        current_page: pagina.current_page,
        per_page: pagina.per_page
      }))
    }
  }
}
</script>
